"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AICentral = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var Units_1 = require("../../Units");
var AICentral = (function (_super) {
    __extends(AICentral, _super);
    function AICentral() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.AI_CENTRAL,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.BUILDING],
            cost: 21,
            productionBox: Units_1.Units.of({ energy: -1 }),
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.tag(Tags_1.Tags.SCIENCE, 3); }),
            metadata: {
                description: {
                    text: 'Requires 3 Science tags to play. Decrease your Energy production 1 step.',
                    align: 'left',
                },
                cardNumber: '208',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Draw 2 cards.', function (ab) { return ab.empty().startAction.cards(2); }).br;
                    b.production(function (pb) { return pb.minus().energy(1); });
                }),
                victoryPoints: 1,
            },
        }) || this;
    }
    AICentral.prototype.canPlay = function (player) {
        return player.getProduction(Resources_1.Resources.ENERGY) >= 1;
    };
    AICentral.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.ENERGY, -1);
        return undefined;
    };
    AICentral.prototype.canAct = function () {
        return true;
    };
    AICentral.prototype.getVictoryPoints = function () {
        return 1;
    };
    AICentral.prototype.action = function (player) {
        player.drawCard(2);
        return undefined;
    };
    return AICentral;
}(Card_1.Card));
exports.AICentral = AICentral;
